const packageJson = require('./../../package.json');

export default function() {
    return packageJson.version;
}